<template>
  <Layout :removePadding="true" :onlyLogoHeader="true">
    <v-card class="elevation-0">
      <v-card-text class="pt-10">
        <h1 class="text-center pt-10 pb-5" style="color: var(--primary-color-blue);">
          {{
            change
              ? $t("change_password.title")
              : $t("sign_up.set_password.title")
          }}
        </h1>
        <p class="text-center" style="color: var(--primary-color-blue);">
          {{
            change
              ? $t("change_password.subtitle")
              : $t("sign_up.set_password.subtitle")
          }}
        </p>
      </v-card-text>
    </v-card>

    <div class="mt-13 mx-10">
      <v-col style="color: var(--primary-color-blue);" class="py-5" v-for="(field, i) in fields" :key="i">
        <v-row>
          {{
            change
              ? $t("change_password." + i)
              : $t("sign_up.set_password." + i)
          }}
        </v-row>
        <v-row align="center" justify="space-around">
          <v-text-field
            flat
            solo
            hide-details
            single-line
            :append-icon="showPassword ? 'visibility_off' : 'visibility'"
            @click:append="showPassword = !showPassword"
            v-model="fields[i]"
            :type="showPassword ? 'text' : 'password'"
            class="input-custom"
          >
          </v-text-field>
        </v-row>
      </v-col>
      <span v-if="error" class="red--text pl-3">{{ $t(`${error}`) }}</span>
    </div>

    <div class="mt-13 mx-10">
      <v-btn
        :disabled="disabledButton"
        class="px-13 py-7 w-100 semi-rounded text-over-secondary--text"
        style="color: white !important; background: var(--primary-color-blue);"
        x-large
        outlined
        outlined-border-width="7"
        :loading="sentRequest"
        @click="change ? changePassword() : setPassword()"
      >
        {{ $t("sign_up.confirm_password") }}
      </v-btn>
      <div class="mx-10">
        <p class="text-center pt-10 clickable" style="text-decoration: underline; color: var(--primary-color-blue);" @click="$router.push({ name: routeNames.LOGIN })">
            {{ $t("sign_up.go_back") }}
        </p>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import RedirectHandler from "@/mixins/RedirectHandler";
import errorManager from "../services/error.manager";
import { TokenPassword } from "../entities/request-bodies/TokenPassword";

export default {
  name: "SetPasswordView",
  props: ["routeNames", "auth"],
  mixins: [RedirectHandler],
  data() {
    return {
      token: null,
      change: null,
      fields: {
        password: null,
        repeat_password: null,
      },
      sentRequest: false,
      showPassword: false,
      error: null,
    };
  },
  methods: {
    setPassword() {
      const context = this;
      this.sentRequest = true;
      const credentials = new TokenPassword(this.token, this.fields.password);
      this.auth
        .setPassword(context, credentials)
        .then(() => {
          const action = "set_password";
          const viewData = {
            primary_text: {
              vicon: "check_circle",
              text: "sign_up.set_password.email_send",
            },
            secondary_text: "sign_up.set_password.email_send_subtitle",
            redirectTo: "WALLET",
          };

          this.successRedirect(action, viewData, true);
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        })
        .finally(() => {
          context.sentRequest = false;
        });
    },
    changePassword() {
      const context = this;
      this.sentRequest = true;
      const credentials = new TokenPassword(this.token, this.fields.password);
      this.auth
        .changePassword(context, credentials)
        .then(() => {
          const action = "set_password";
          const viewData = {
            primary_text: {
              vicon: "check_circle",
              text: "change_password.email_send",
            },
            secondary_text: "change_password.email_send_subtitle",
            redirectTo: "WALLET",
          };

          this.successRedirect(action, viewData, true);
        })
        .catch((error) => {
          errorManager.manageError(context, error);
        })
        .finally(() => {
          context.sentRequest = false;
        });
    },
  },
  computed: {
    disabledButton() {
      this.error = null;
      if (this.fields.password == null || this.fields.repeat_password == null) {
        return true;
      } else if (this.fields.password != this.fields.repeat_password) {
        this.error = "sign_up.set_password.no_match";
        return true;
      }else if (this.fields.password.length < 8 || this.fields.repeat_password.lenth < 8) {
        this.error = "sign_up.set_password.short_password";
        return true;
      }
      return false;
    },
  },
  async created() {
    this.token = this.$route.query.token;
    this.change = this.$route.query.change;
  },
  components: {
    Layout,
  },
};
</script>

<style>
.theme--light.v-btn.v-btn--disabled {
  opacity: 0.5 !important;
}
</style>
